import React from 'react'
import PropTypes from 'prop-types'

import equalHousingOpportunityImage from './equal-housing-opportunity.svg'
import equalHousingLenderImage from './equal-housing-lender.svg'

import styles from './HousingType.module.scss'

const propTypes = {
  className: PropTypes.string,
  equalHousingType: PropTypes.oneOf(['lender', 'opportunity'])
}

const imagePropsForType = {
  lender: {
    src: equalHousingLenderImage,
    alt: 'Equal Housing Lender'
  },
  opportunity: {
    src: equalHousingOpportunityImage,
    alt: 'Equal Housing Opportunity'
  }
}

const HousingType = ({ className, equalHousingType }) => {
  const imageProps = imagePropsForType[equalHousingType]

  if (!imageProps) {
    return null
  }

  return (
    <div className={className}>
      <img alt='Equal Housing' className={styles.image} {...imageProps} />
    </div>
  )
}

HousingType.propTypes = propTypes

export default HousingType
